module.exports = __webpack_public_path__ + "img/protective_icon.fe90c311.svg";